module.exports = __webpack_public_path__ + "img/tip.db68a7bf.png";